import React from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { PartyPopper, MapPin, Clock, CalendarDays, ArrowRight, Plus } from "lucide-react";
import { PillButton } from "../../components/ui/PillButton";
import { StickerCard } from "../../components/ui/StickerCard";
import { Confetti } from "../../components/ui/Confetti";
import { useApp } from "../../context/AppContext";
import { EVENT } from "../../data/mockData";

export default function BookingConfirmation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { getActivity, getSlot } = useApp();
  const { code, ref, activityId, slotId } = location.state || {};

  if (!code || !ref) return <Navigate to="/my-booking" replace />;
  const activity = getActivity(activityId);
  const slot = getSlot(activityId, slotId);

  return (
    <div className="relative max-w-xl mx-auto px-4 py-12">
      <Confetti />
      <div className="text-center">
        <div className="mx-auto w-20 h-20 rounded-full bg-lime flex items-center justify-center shadow-playful animate-pop-in">
          <PartyPopper className="w-10 h-10 text-sea-deep" />
        </div>
        <h1 className="mt-4 font-display text-4xl text-coral sticker-text-sm">Activity Booked! 🎉</h1>
        <p className="mt-3 font-bold text-sea-deep/80">Sampai jumpa di keseruannya!</p>
      </div>

      <StickerCard className="mt-8 overflow-hidden" data-testid="booking-confirm-card">
        <div className="bg-sky-dark text-white p-5 flex items-center gap-4">
          <img src={activity?.icon} alt="" className="w-14 h-14 object-contain bg-white/20 rounded-2xl p-1.5" />
          <div>
            <p className="font-display text-2xl">{activity?.name}</p>
            <p className="text-white/80 text-sm font-semibold">Booking Ref: {ref}</p>
          </div>
        </div>
        <div className="p-6 grid grid-cols-2 gap-4">
          <Row icon={<CalendarDays className="w-4 h-4" />} label="Tanggal" value={EVENT.dateLabel} />
          <Row icon={<Clock className="w-4 h-4" />} label="Waktu" value={slot ? `${slot.start}–${slot.end}` : "-"} />
          <Row icon={<MapPin className="w-4 h-4" />} label="Lokasi" value={activity?.location} />
          <Row label="Kode Tiket" value={code} />
        </div>
      </StickerCard>

      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
        <PillButton size="lg" onClick={() => navigate("/my-booking", { state: { code } })} data-testid="booking-view-activities">
          View My Activities <ArrowRight className="w-5 h-5" />
        </PillButton>
        <PillButton size="lg" variant="secondary" onClick={() => navigate("/my-booking", { state: { code } })} data-testid="booking-book-another">
          <Plus className="w-5 h-5" /> Book Another
        </PillButton>
      </div>
    </div>
  );
}

const Row = ({ icon, label, value }) => (
  <div>
    <p className="text-xs uppercase font-bold text-sea-deep/50 flex items-center gap-1">{icon}{label}</p>
    <p className="mt-1 font-display text-sea-deep">{value}</p>
  </div>
);
